var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VpnAuthInstaller')
}
var staticRenderFns = []

export { render, staticRenderFns }